import React from 'react';

const MessageLimitReached: React.FC = () => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-gradient-to-br from-blue-50 to-purple-50">
      <div className="max-w-2xl mx-auto p-8 bg-white rounded-2xl shadow-xl">
        <div className="flex flex-col items-center text-center space-y-6">
          {/* Company Logo */}
          <div className="mb-4">
            <img 
              src="/logo_blue_full.png" 
              alt="EnablAI Logo" 
              className="h-20 w-auto"
            />
          </div>
          
          {/* Title */}
          <h1 className="text-3xl font-bold text-gray-900">
            Free Message Limit Reached
          </h1>
          
          {/* Message */}
          <div className="space-y-4 text-gray-700">
            <p className="text-lg">
              You've reached the maximum number of free messages available in your account.
            </p>
            <p>
              To continue using our service and unlock unlimited access, please contact us to upgrade your plan.
            </p>
          </div>
          
          {/* Contact Information */}
          <div className="bg-blue-50 rounded-lg p-6 w-full">
            <h2 className="text-xl font-semibold text-gray-900 mb-3">
              Get in Touch
            </h2>
            <div className="space-y-2">
              <div className="flex items-center justify-center space-x-2">
                <svg 
                  className="w-5 h-5 text-blue-600" 
                  fill="none" 
                  stroke="currentColor" 
                  viewBox="0 0 24 24"
                >
                  <path 
                    strokeLinecap="round" 
                    strokeLinejoin="round" 
                    strokeWidth={2} 
                    d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" 
                  />
                </svg>
                <a 
                  href="mailto:admin@e-nablai.com" 
                  className="text-blue-600 hover:text-blue-800 font-medium text-lg transition-colors"
                >
                  admin@e-nablai.com
                </a>
              </div>
            </div>
          </div>
          
          {/* Additional Information */}
          <div className="text-sm text-gray-500 pt-4">
            <p>
              Our team will get back to you shortly to discuss upgrade options tailored to your needs.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MessageLimitReached;
